import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteUser($id: ID!) {
        deleteUser(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
